/* eslint-disable no-confusing-arrow */
import appConfig from '../../configs/app';
import { MATERIAL_STOCK_STATUS } from '../constants';
import { converseMaterialOrProductUnit } from '../functions/converseMaterialOrProductUnit';

const columns = [
  {
    label: 'ลำดับที่',
    value: 'index',
  },
  {
    label: 'รหัสวัตถุดิบ',
    value: 'type_code',
  },
  {
    label: 'ขื่อวัตถุดิบ',
    value: 'name',
  },
  {
    label: 'คงเหลือ',
    value: 'total',
  },
  {
    label: 'หน่วย',
    value: (col) =>
      col?.use_unit_conversion ? col?.unit_input?.short_sign : col?.unit,
  },
  {
    label: 'คงเหลือ (หน่วยที่สอง)',
    value: (col) =>
      col?.use_unit_conversion
        ? converseMaterialOrProductUnit(col, col?.total)
        : '',
  },
  {
    label: 'หน่วย',
    value: (col) =>
      col?.use_unit_conversion ? col?.unit_output?.short_sign : '-',
  },
];

const columnWithoutStock = [
  {
    label: 'ลำดับที่',
    value: 'index',
  },
  {
    label: 'รหัสวัตถุดิบ',
    value: 'type_code',
  },
  {
    label: 'ขื่อวัตถุดิบ',
    value: 'name',
  },
  {
    label: 'ประเภทวัตถุดิบ',
    value: (col) => col?.material_type?.name,
  },
  {
    label: 'หน่วย',
    value: (col) =>
      col?.use_unit_conversion ? col?.unit_input?.short_sign : col?.unit,
  },
  {
    label: 'หน่วยที่สอง',
    value: (col) =>
      col?.use_unit_conversion ? col?.unit_output?.short_sign : '-',
  },
];

const columnWithMaterialDouble = [
  {
    label: 'ลำดับที่',
    value: 'index',
  },
  {
    label: 'รหัสวัตถุดิบ',
    value: (col) => col?.material?.type_code,
  },
  {
    label: 'ขื่อวัตถุดิบ',
    value: (col) => col?.material?.name,
  },
  {
    label: 'จำนวน',
    value: 'quantity',
  },
  {
    label: 'หน่วย',
    value: (col) =>
      col?.material?.use_unit_conversion
        ? col?.material?.unit_input?.short_sign
        : col?.material?.unit,
  },
  {
    label: 'คงเหลือ (หน่วยที่สอง)',
    value: (col) =>
      col?.material?.use_unit_conversion
        ? converseMaterialOrProductUnit(col?.material, col?.quantity)
        : '',
  },
  {
    label: 'หน่วย',
    value: (col) =>
      col?.material?.use_unit_conversion
        ? col?.material?.unit_output?.short_sign
        : '',
  },
];

const query = ({ id, selectedMaterialType }) => ({
  place: id || '',
  fetchStockLot: true,
  selectMaterialType: selectedMaterialType || '',
  stockStatus: MATERIAL_STOCK_STATUS.IN_STOCK.status_code,
  fetchProcess: false,
  page: 1,
  size: appConfig.maxFetchSize,
});

export default { columns, query, columnWithoutStock, columnWithMaterialDouble };
